'use strict';

var novicell = novicell || {};

novicell.statsSpot = novicell.statsSpot || new function () {

  this.init = function () {
    if (typeof jQuery !== 'undefined') {
      let stats_spots = document.querySelectorAll('.js-stats-spot-counter');
      if (stats_spots.length) {
        for (let i = 0; i < stats_spots.length; i++) {
          let element = stats_spots[i];
          // Perform counts when the element gets into view
          new Waypoint({
            element: element,
            handler: function() {
              let number = element.dataset.statsNumber;
              if (!isNaN(number)) {
                let options = {
                  useEasing: true,
                  useGrouping: true,
                  separator: element.dataset.statsSeparator,
                  decimal: element.dataset.statsDecimal,
                  prefix: element.dataset.statsPrefix,
                  suffix: element.dataset.statsSuffix
                };
                let counter = new CountUp(element, 0, number, 0, 2.5, options);
                counter.start();
              }
            },
            offset: '100%',
            triggerOnce: true
          });
        }
      }
    }
  };
}();
